import { afterNextRender, Component, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Environment } from '../../../environments/environment';
import { ContactFab } from '../../components/contact-fab/contact-fab';
import { Layout } from '../../components/layout/layout';
import { Map2 } from '../../components/map-2/map-2';
import { Modals } from '../../components/modals/modals';
import { Sidebar } from '../../components/sidebar/sidebar';
import { Toolbar } from '../../components/toolbar/toolbar';
import { ListingsService } from '../../services/listings/listings';
import { SeoService } from '../../services/seo/seo';
import { UrlService } from '../../services/url/url';

@Component({
  imports: [ContactFab, Layout, Map2, Modals, Sidebar, Toolbar],
  selector: 'app-home',
  styleUrl: './home.page.css',
  templateUrl: './home.page.html',
})
export class HomePage {
  protected readonly listingsService = inject(ListingsService);

  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _seoService = inject(SeoService);
  private readonly _urlService = inject(UrlService);

  constructor() {
    afterNextRender(() => {
      /*
      Get the initial URL params and apply them to the filtering service. This ensures that if a user
      shares a URL with specific filters applied, those filters will be set when the page is loaded.
      */
      this._activatedRoute.queryParams.subscribe((params) => {
        const _lowercasedParams = Object.fromEntries(
          Object.entries(params).map(([key, value]) => [key.toLowerCase(), value]),
        );

        this._urlService.populateUrlParams(_lowercasedParams);
      });

      this._seoService.dataLayerPush('property_view', undefined);
    });

    effect(() => {
      this._seoService.update(this.listingsService.selectedListing());

      if (!this.listingsService.selectedListing()) {
        this._seoService.dataLayerPush('property_view', undefined);
      } else {
        this._seoService.dataLayerPush('property_view', {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          page_location: `${Environment.hostUrl}/${this.listingsService.selectedListing()!.id}`,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          page_title: `${this.listingsService.selectedListing()!.address.streetAddress} | ${this.listingsService.selectedListing()!.model?.title} | ${Environment.community === 'villages' ? 'The Villages, FL' : 'Middleton, FL'}`,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          page_type: 'property_detail',
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          property_baths: this.listingsService.selectedListing()?.baths?.value,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          property_beds: this.listingsService.selectedListing()?.beds,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          property_id: this.listingsService.selectedListing()?.id,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Listings should always have an ID, but we guard against it just in case.
          property_price: this.listingsService.selectedListing()?.price,
          // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unnecessary-condition -- Listings should always have an ID, but we guard against it just in case.
          property_sqft: this.listingsService.selectedListing()?.squareFeet?.total,
        });
      }
    });
  }
}
